import {Button} from '@wordpress/components';
import {emit} from '../../../utils';

const SubmitButton = (props: {
    className?: string
}) => {
    let className = 'saa-w-100 saa-justify-content-center';
    if (props.className) {
        className += ' ' + props.className
    }

    function onClick() {
        emit('saa.theme.submit', {});
    }

    return (
        <>
            <Button className={className} variant={ 'secondary' } onClick={ onClick }>
                SUBMIT FORM
            </Button>
        </>
    );
};

export default SubmitButton;
